import { TRUNCATE_ATTR } from "@carbon6/c6-frontend-design";

// 자기 ellipsis CSS 를 이미 가진 요소에 붙이는 c6 잘림 마커. 앱 루트의
// `TruncationTooltipHost` 가 이 마커를 찾아 hover/focus 때 전체 값을 표시한다.
// 이 마커는 표에서 특히 필요하다. c6 DataTable 은 plain 값 셀에만 마커를 추가하고 render
// 컬럼은 바꾸지 않는다. 그래서 render 가 그린 요소는 직접 마커를 가져야 한다.
// 잘리는 요소와 마커는 같은 요소여야 한다. 감싸는 래퍼에 붙이면 안쪽 요소가 먼저 잘린다.
// 그러면 바깥 요소는 넘치지 않는다. 새로 그리는 평범한 텍스트는 c6 `TruncatedText` 를
// 그대로 쓴다(한 줄 ellipsis + 마커).
export const truncationMarkerProps = { [TRUNCATE_ATTR]: "" } as const;
